import { Component, input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-advice-card',
    templateUrl: './advice-card.component.html',
    styleUrl: './advice-card.component.scss',
    imports: [
        MatIconButton,
        MatTooltip,
        MatIcon,
    ],
})
export class AdviceCardComponent {
  title = input.required<string>();
  infoTooltipText = input<string | null>(null);
}
